
import React from 'react';

import { translate } from '../../../base/i18n';
import { IconMuteEveryoneElse } from '../../../base/icons';
import { connect } from '../../../base/redux';
import AbstractForceMuteEveryone, {
    type Props
} from '../AbstractForceMuteEveryone';

import VideoMenuButton from './VideoMenuButton';

/**
 * Implements a React {@link Component} which displays a button for audio muting
 * every participant in the conference except the one with the given
 * participantID.
 */
class ForceMuteEveryone extends AbstractForceMuteEveryone {
    /**
     * Instantiates a new {@code Component}.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this._onClick = this._handleClick.bind(this);
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { participantID } = this.props;

        return (
            <VideoMenuButton
                buttonText = 'Force Mute Everyone'
                displayClass = { 'mutelink' }
                icon = { IconMuteEveryoneElse }
                id = { `mutelink_${participantID}` }

                onClick = { this._onClick } />
        );
    }

    _onClick: () => void;
}

export default translate(connect()(ForceMuteEveryone));
